//  INFO: routes in this array will not have the choose asset component in the header

import routes from '@/shared/constant/routes';

export const assetBlacklist = [
  routes.settings,
  routes.addNewStock,
  routes.subscription,
  routes.billing,
  `${routes.periodicJobs}/[id]`,
  `${routes.propertySettings}/[id]/[field]`,
  `${routes.contracts}/[id]`,
  routes.companySettings,
];

export const subscriptionBlacklist = [
  routes.billing,
  routes.login,
  routes.loginOtp,
  routes.signup,
  routes.resetPassword,
  routes.createPassword,
  routes.forgotPassword,
  routes.finalizeBilling,
];
